// extracted by mini-css-extract-plugin
export default {"wrapper":"ou-z","button":"pu-z","alternate":"qu-z","disabled":"ru-z","paymentWarning":"su-z","fadeIn":"tu-z"};